module.exports = __webpack_public_path__ + "media/new/residential-32-7df943ca.png";